import { Option } from "@pages/Assistant/components/AssistantForm";
import { useProject } from "@utils/useProject";
import React, { useEffect, useState, useRef } from "react";

interface InviteMemberModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const InviteMemberModal: React.FC<InviteMemberModalProps> = ({
  isOpen,
  onClose,
}) => {
  const [projects, setProjects] = useState<Option[]>([]);
  const [selectedProject, setSelectedProject] = useState<Option | null>(null);
  const [open, setOpen] = useState(false);

  const dropdownRef = useRef<HTMLDivElement>(null);
  const { getProjectsDropdown } = useProject();

  useEffect(() => {
    (async () => {
      const fetchedProjects = await getProjectsDropdown();

      setProjects(
        fetchedProjects.map((project: any) => ({
          id: project.id.toString(),
          name: project.name,
        }))
      );
    })();
  }, []);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(e.target as Node)
      ) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-30 flex justify-center items-center z-50">
      <div className="bg-white rounded-md w-full max-w-xl shadow-lg relative">
        <div className="px-6 py-3 border-b border-gray-200">
          <h2 className="text-lg font-semibold mt-1">
            Invite People to THE ARK
          </h2>
        </div>
        <div className="p-6">
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Send invite to:
            </label>
            <input
              type="email"
              placeholder="Add email"
              className="w-full border px-3 py-3 rounded text-sm"
            />
          </div>

          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Project
            </label>
            <div className="relative" ref={dropdownRef}>
              <button
                type="button"
                onClick={() => setOpen(!open)}
                className="w-full border px-3 py-3 rounded text-sm flex justify-between items-center"
              >
                <span>
                  {selectedProject ? selectedProject.name : "Select a project"}
                </span>
                <svg
                  className={`w-4 h-4 transition-transform ${
                    open ? "rotate-180" : ""
                  }`}
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </button>
              {open && (
                <div className="absolute mt-1 w-full bg-white border rounded shadow-lg z-50 max-h-60 overflow-auto">
                  {projects.length > 0 ? (
                    projects.map((proj) => (
                      <button
                        key={proj.id}
                        onClick={() => {
                          setSelectedProject(proj);
                          setOpen(false);
                        }}
                        className="w-full text-left px-3 py-2 hover:bg-gray-100 text-sm"
                      >
                        {proj.name}
                      </button>
                    ))
                  ) : (
                    <div className="px-3 py-2 text-sm text-gray-500">
                      No projects found
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="flex justify-end px-6 py-4 border-t border-gray-200">
          <button
            onClick={onClose}
            className="mr-3 px-4 py-2 rounded text-sm text-gray-600 border border-gray-300 hover:bg-gray-100"
          >
            Close
          </button>
          <button className="bg-blue-600 text-white px-4 py-2 rounded text-sm hover:bg-blue-700">
            Send Invite
          </button>
        </div>
      </div>
    </div>
  );
};

export default InviteMemberModal;
